module.exports = __webpack_public_path__ + "img/1534652239.9ccd6deb.jpg";